import { toBlob } from 'html-to-image';
import { downloadBlob, waitForCardAssets } from '@/features/guide-identity/utils/cardExport';
import { PROMO_SIZES, type PromoFormat } from '../components/PromoPostCanvas';

/** Renders the offscreen promo node at its exact social-media pixel size. */
export async function renderPromoBlob(node: HTMLElement, format: PromoFormat): Promise<Blob> {
  await waitForCardAssets(node);
  const { width, height } = PROMO_SIZES[format];
  const blob = await toBlob(node, { width, height, pixelRatio: 1, cacheBust: false });
  if (!blob) throw new Error('Promo image encoding failed');
  return blob;
}

export function promoFileName(format: PromoFormat): string {
  return `trplin-join-as-guide-${format}.png`;
}

export async function renderPromoFile(node: HTMLElement, format: PromoFormat): Promise<File> {
  const blob = await renderPromoBlob(node, format);
  return new File([blob], promoFileName(format), { type: 'image/png' });
}

export async function downloadPromo(node: HTMLElement, format: PromoFormat): Promise<void> {
  downloadBlob(await renderPromoBlob(node, format), promoFileName(format));
}
